import { render, staticRenderFns } from "./courseSuitableUser.vue?vue&type=template&id=987416e6&scoped=true"
import script from "./courseSuitableUser.vue?vue&type=script&lang=js"
export * from "./courseSuitableUser.vue?vue&type=script&lang=js"
import style0 from "./courseSuitableUser.vue?vue&type=style&index=0&id=987416e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "987416e6",
  null
  
)

export default component.exports